import { formatAmount } from '@common/utils';

export function TopSpacesList({
  topSpacesData,
}: {
  topSpacesData: { id: string; name: string; count: number; revenue: number }[];
}) {
  return (
    <div className="bg-white border border-slate-200 rounded-xl shadow-sm overflow-hidden flex-1 flex flex-col">
      <div className="px-5 py-4 border-b border-slate-100 flex items-center justify-between bg-slate-50/50">
        <h3 className="font-semibold text-slate-800 flex items-center gap-2">Palmarès des Espaces</h3>
        <div className="p-1.5 bg-primary/10 text-primary rounded text-xs font-bold">TOP 4</div>
      </div>
      <div className="p-4 flex flex-col gap-3 overflow-y-auto flex-1 h-[200px]">
        {topSpacesData.length === 0 ? (
          <div className="h-full flex items-center justify-center text-sm text-slate-400">
            Aucun espace sur ces filtres.
          </div>
        ) : (
          topSpacesData.map((space, i) => {
            return (
              <div
                key={i}
                className="flex gap-3 items-center justify-between p-3 bg-white rounded-lg border border-slate-100 shadow-[0_1px_2px_rgba(0,0,0,0.02)] transition-colors hover:border-slate-200 group"
              >
                <div className="flex items-center gap-3">
                  <div className="flex items-center justify-center w-8 h-8 rounded-full bg-slate-100 text-slate-600 font-bold text-xs group-hover:bg-primary/10 group-hover:text-primary transition-colors">
                    #{i + 1}
                  </div>
                  <div>
                    <p className="text-sm font-medium text-slate-800 leading-snug truncate">
                      {space.name}
                    </p>
                    <span className="text-xs text-slate-400 mt-0.5 block">{space.count} réservations</span>
                  </div>
                </div>
                <div className="font-semibold text-slate-900 text-sm">{formatAmount(space.revenue)}</div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}
